import color from 'styles/color';

export type Settlements = Settlement[];

export interface Settlement {
  id: number;
  coach_user: CoachUser;
  challenge: Challenge;
  settlement_date: string;
  net_amount: number;
  raw_amount: number;
  fee_amount: number;
  fee_rate: number;
  settled_at: string;
  status: SETTLEMENTS_STATUS;
  account: any;
  base_year_month: string;
  user_count: number;
}

export interface CoachUser {
  id: number;
  email: string;
  nickname: string;
  avatar_url: string;
  user_id: number;
  name: string;
}
export enum SETTLEMENTS_STATUS {
  WAITING = 'WAIT',
  DONE = 'DONE',
  SELLING = 'SELL',
  FAILED = 'FAIL',
}

export const SettlementsStatus = {
  [SETTLEMENTS_STATUS.WAITING]: '정산 예정',
  [SETTLEMENTS_STATUS.DONE]: '정산 완료',
  [SETTLEMENTS_STATUS.SELLING]: '판매 중',
  [SETTLEMENTS_STATUS.FAILED]: '정산 취소',
};
export const SettlementsStatusColor = {
  [SETTLEMENTS_STATUS.WAITING]: color.blue06,
  [SETTLEMENTS_STATUS.DONE]: color.green06,
  [SETTLEMENTS_STATUS.SELLING]: color.gray05,
  [SETTLEMENTS_STATUS.FAILED]: color.red06,
};

export interface Challenge {
  id: number;
  name: string;
  description: string;
  purpose: string;
  total_date: number;
  author: string;
  youtube_id: any;
  thumbnail_image: any;
  writer: number;
  activated: boolean;
  is_private: boolean;
  protein_price: number;
}
